import { INewRelicConfig } from '@assess/browser/new-relic';

import { environment } from '../../environments/environment';

export const newRelicConfig: INewRelicConfig = environment.newRelic;
